import { Form, Input } from 'antd';
import { postApi, putApi } from 'apis';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { FC, useContext, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';
const AddCompanyBody: FC<SideDrawerBodyProps> = (props) => {
	const permissionContext = useContext(PermissionContext);

	const [loading, setLoading] = useState<boolean>(false);
	const { closeDrawerByAnimation, fetchCompanyData, editSelectedUser } =
		props;

	const buttons = [
		{
			text: `Cancel`,
			isLoading: false,
			className: 'btn-cancel',
			isSubmit: true,
			disabled: loading,
			onclick: () => {
				closeDrawerByAnimation();
			},
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
		},
		{
			text: 'Save',
			isLoading: loading,
			className: 'btn-blue',
			isSubmit: true,
			disabled: false,
			onclick: () => {},
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
		},
	];

	const handleSubmit = async (values: any) => {
		if (editSelectedUser) {
			let data: any = {
				companyId: editSelectedUser?.id,
				...values,
			};

			await updateCompany(data);
		} else {
			await addCompany(values);
		}
	};

	const updateCompany = async (data: any) => {
		try {
			setLoading(true);
			await putApi('/company', data);
			if (permissionContext.companyId === editSelectedUser?.id) {
				window.location.reload();
			} else {
				fetchCompanyData();
				closeDrawerByAnimation();
			}
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in updating company';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};
	const addCompany = async (finalData: any) => {
		try {
			setLoading(true);
			const response = await postApi('/company/create', finalData);
			fetchCompanyData();
			window.location.reload();
			let message =
				response?.data?.message || 'Company created successfully';
			toastText(message, 'success');
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong when creating to company';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles['side-drawer-body']}>
			<Form
				name="basic"
				className={styles['side-drawer-form']}
				labelCol={{ span: 8 }}
				wrapperCol={{ span: 16 }}
				style={{ maxWidth: 600 }}
				onFinish={handleSubmit}
				initialValues={editSelectedUser}
				autoComplete="off"
			>
				<p className={styles['form-container-head-warning']}>
					<b>
						{' '}
						<sup>*</sup>
					</b>{' '}
					Indicated mandatory fields
				</p>
				<div className={styles['side-drawer-form__inputs']}>
					<label className={styles['side-drawer-form__role--label']}>
						{'Company Name'}{' '}
						<span className="required-color">*</span>
					</label>
					<Form.Item
						// className="side-drawer-form__role"
						name={'name'}
						rules={[
							{
								required: true,
								message: 'Company name required',
								validateTrigger: 'onChange',
								validator: (_, value) =>
									value && value.trim() !== ''
										? Promise.resolve()
										: Promise.reject(new Error('Please enter value')),
							},
					
						]}
						wrapperCol={{ span: 24 }}
					>
						<Input
							className="remove-antd-input-effect"
							maxLength={150}
							size="large"
							disabled={false}
							type={'text'}
				
						/>
					</Form.Item>
				</div>
				<div className={styles['side-drawer-form__inputs']}>
					<label className={styles['side-drawer-form__role--label']}>
						{'Company TPIN'}{' '}
						<span className="required-color">*</span>
					</label>
					<Form.Item
						name={'tpin'}
						rules={[
							{
								required: true,
								message: 'Company tpin required',
								validateTrigger: 'onChange',
							},
							{
								message:
									'Company tpin length must have 10 digits',
								pattern: /^\d{10}$/,
								validateTrigger: 'onChange',
							},
						]}
						wrapperCol={{ span: 24 }}
					>
						<Input
							className="remove-antd-input-effect"
							maxLength={150}
							size="large"
							disabled={false}
							type={'number'}
						
						/>
					</Form.Item>
				</div>
				{editSelectedUser?.CompanyDetails && (
					<>
						<div className={styles['side-drawer-form__inputs']}>
							<label
								className={
									styles['side-drawer-form__role--label']
								}
							>
								{'NAPSA Number'}{' '}
							</label>
							<Form.Item
								name={'napsa'}
								wrapperCol={{ span: 24 }}
							>
								<Input
									className="remove-antd-input-effect"
									maxLength={150}
									size="large"
									disabled={false}
									type={'text'}
								
								/>
							</Form.Item>
						</div>
						<div className={styles['side-drawer-form__inputs']}>
							<label
								className={
									styles['side-drawer-form__role--label']
								}
							>
								{'NHIMA Number'}{' '}
							</label>
							<Form.Item
								name={'nhima'}
								wrapperCol={{ span: 24 }}
							>
								<Input
									className="remove-antd-input-effect"
									maxLength={150}
									size="large"
									disabled={false}
									type={'text'}
									
								/>
							</Form.Item>
						</div>
					</>
				)}

				<div className={styles['side-drawer-form__inputs']}>
					<label className={styles['side-drawer-form__role--label']}>
						{'Company Email'}{' '}
						<span className="required-color">*</span>
					</label>
					<Form.Item
						name={'email'}
						rules={[
							{
								message: 'Please enter your company email',
								validateTrigger: 'onChange',
							},
							{
								type: 'email',
								message: 'Please enter valid email',
								validateTrigger: 'onChange',
							},
						]}
						required={true}
						wrapperCol={{ span: 24 }}
					>
						<Input
							className="remove-antd-input-effect"
							maxLength={150}
							size="large"
							disabled={false}
							type={'email'}
						/>
					</Form.Item>
				</div>
				<div className={styles['side-drawer-form__inputs']}>
					<label className={styles['side-drawer-form__role--label']}>
						{'Company Address'}{' '}
					</label>
					<Form.Item
						name={'address'}
						rules={[
							{
								message: 'Please enter your company address',
								validateTrigger: 'onChange',
							},
					
						]}
						wrapperCol={{ span: 24 }}
					>
						<textarea
							className={styles['side-drawer-form--textarea']}
						/>
					</Form.Item>
				</div>

				<div className={styles['side-drawer-form__buttons']}>
					<Form.Item>
						<Buttons buttons={buttons} />
					</Form.Item>
				</div>
			</Form>
		</div>
	);
};

export default AddCompanyBody;
